import React from 'react';
import { useData } from '../contexts/DataContext';

function SystemConfig({ showToast }) {
  const { initSampleData, clearChangedData } = useData();

  const handleInitData = () => {
    const confirmed = window.confirm(
      'Bạn có chắc muốn Init dữ liệu?\n\nThao tác sẽ khởi tạo lại dữ liệu mẫu mặc định của hệ thống.'
    );
    if (!confirmed) return;

    initSampleData();
    showToast && showToast('✅ Đã init dữ liệu mẫu mặc định!', 'success');
  };

  const handleClearChangedData = () => {
    const confirmed = window.confirm(
      'Bạn có chắc muốn clear dữ liệu thay đổi?\n\nThao tác sẽ xóa các thay đổi phát sinh (case/rules/users local) và đưa dữ liệu về mặc định.'
    );
    if (!confirmed) return;

    clearChangedData();
    showToast && showToast('✅ Đã clear dữ liệu thay đổi thành công!', 'success');
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky mb-4">
        <h2 className="mb-1">
          <i className="bi bi-sliders me-2"></i>
          Cấu hình hệ thống
        </h2>
        <p className="text-muted mb-0">Quản lý các thao tác khởi tạo và làm sạch dữ liệu mẫu</p>
      </div>

      <div className="row g-4">
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title d-flex align-items-center">
                <i className="bi bi-database-add me-2 text-primary"></i>
                Init dữ liệu
              </h5>
              <p className="text-muted">
                Khởi tạo lại dữ liệu mẫu mặc định cho khách hàng, mô hình, cảnh báo và dọn dữ liệu phát sinh.
              </p>
              <button className="btn btn-primary" onClick={handleInitData}>
                <i className="bi bi-play-circle me-2"></i>
                Init dữ liệu
              </button>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title d-flex align-items-center">
                <i className="bi bi-trash3 me-2 text-danger"></i>
                Clear dữ liệu thay đổi
              </h5>
              <p className="text-muted">
                Xóa các dữ liệu phát sinh trong quá trình test/vận hành demo và đưa hệ thống về trạng thái dữ liệu chuẩn.
              </p>
              <button className="btn btn-outline-danger" onClick={handleClearChangedData}>
                <i className="bi bi-arrow-counterclockwise me-2"></i>
                Clear dữ liệu thay đổi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemConfig;
